import Select, { SelectProps } from '..';
import SvgRender from '@/library/components/general/SvgRender';
import { GroupBase, MultiValue } from 'react-select';
import {
  AsyncCreatableSelectProps,
  AsyncSelectProps,
  CreatableSelectProps,
  DefaultSelectProps
} from '../types';

export type IconSelectProps = {
  hideIcon?: boolean;
  iconStyle?: React.CSSProperties;
  icon: string;
  containerClassName?: string;
  // IconSelect must not receive a label — FormGroupWrap's label breaks the icon layout.
};

function IconSelect<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>({
  size,
  isMulti,
  value,
  hideIcon,
  iconStyle,
  icon,
  containerClassName = '',
  ...rest
}: (
  | CreatableSelectProps<Option, IsMulti, Group>
  | AsyncCreatableSelectProps<Option, IsMulti, Group>
  | AsyncSelectProps<Option, IsMulti, Group>
  | DefaultSelectProps<Option, IsMulti, Group>
) &
  SelectProps<Option> &
  IconSelectProps) {
  const iconSize = size === 'sm' ? 14 : 16;

  return (
    <div
      className={`icon-select${
        (isMulti ? !(value as MultiValue<Option> | null)?.length : !value)
          ? ' icon-select--empty'
          : ''
      } ${containerClassName} ${hideIcon ? 'icon-select--hide-icon' : ''}`}
    >
      <div className="icon-select__icon">
        <SvgRender src={icon} style={iconStyle || { height: iconSize, width: iconSize }} />
      </div>

      <Select isMulti={isMulti} value={value} size={size} {...rest} />
    </div>
  );
}

export default IconSelect;
